import { render, staticRenderFns } from "./WrongModal.vue?vue&type=template&id=d68f3da4&scoped=true"
import script from "./WrongModal.vue?vue&type=script&lang=js"
export * from "./WrongModal.vue?vue&type=script&lang=js"
import style0 from "./WrongModal.vue?vue&type=style&index=0&id=d68f3da4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d68f3da4",
  null
  
)

export default component.exports